module.exports = __webpack_public_path__ + "static/media/backButton.95f5ce0d.svg";